module.exports = __webpack_public_path__ + "static/media/financial.7a9fb86a.svg";